// Routes owned by the MailerCampaign module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const mailerCampaignPaths = {
    // Mailer Campaign
    mailerCampaign: '/mailers/campaigns',
    mailerCampaignDetail: '/mailers/campaigns/:id',
    mailerCampaignCreate: '/mailers/campaigns/new',
    // Unreferenced: no paths.* caller; route is live (/mailers/campaigns/:id/edit).
    mailerCampaignEdit: '/mailers/campaigns/:id/edit',
    mailerTemplateCreate: '/mailers/campaigns/templates/new',
    mailerTemplateDetail: '/mailers/campaigns/templates/:id',
    mailerTemplateEdit: '/mailers/campaigns/templates/:id/edit',
} as const
